import { CSSProperties } from 'react';
import styled from 'styled-components';

export const DisciplinesWrapper = styled.div`
  padding: 29px 29px 25px;
  transition: all 0.3s linear;

  @media (min-width: 992px) {
    padding: 26px 29px;
  }
`;

export const Title = styled.span`
  font-size: 18px;
  font-weight: 700;
  padding: 10px 0;
`;

export const Label = styled.div`
  font-size: 18px;
  padding: 10px 0;
`;

export const CheckboxesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 10px 0;
  margin: 0 -20px;
`;

export const CheckboxColumn = styled.div`
  padding: 0 20px 20px;
  width: 20%;

  @media (max-width: 991px) {
    width: 25%;
  }

  @media (max-width: 767px) {
    width: 33%;
  }
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 0 8px;

  input {
    height: 30px !important;
    margin-left: 10px;
    margin-bottom: 0.5rem;
    max-width: 250px;
  }
`;

export const TooltipContent = styled.div`
  display: flex;
  gap: 5px;
`;

export const TooltipIconWrapper: CSSProperties = {
  fontSize: '10px',
  paddingTop: '4px',
};
